import { countries as cntrs, languages as lngs } from 'countries-list';

const countries = Object.keys(cntrs)
  .map((code) => {
    const cData = cntrs[code];

    const languages = cData.languages.map((c) => {
      return {
        ...lngs[c],
        code: c,
      };
    });

    return {
      code,
      name: cData.name,
      native: cData.native,
      languages,
      emoji: cData.emoji,
      emojiU: cData.emojiU,
    };
  });

export const languages = Object.keys(lngs)
  .filter(code => !!lngs[code].name)
  .map((code) => {
    const lData = lngs[code];
    return {
      code,
      name: lData.name,
      native: lData.native,
      direction: lData.rtl ? 'RTL' : 'LTR',
    };
  });


const getLanguage = code => languages.filter(u => u.code === code);

export default {
  countries,
  getLanguage,
};
